const images = {
  statusIcon: {
    approved: require("../../assets/icons/calendar.svg"),
    pending: require("../../assets/icons/calendar.svg"),
    rejected: require("../../assets/icons/calendar.svg")
  },
  calendar: {
    calendar: require("../../assets/icons/calendar.svg")
  },
  // TODO: check if it is in use or remove
  fundListIcon: {
    view: require("../../assets/icons/calendar.svg"),
    edit: require("../../assets/icons/calendar.svg"),
    locked: require("../../assets/icons/calendar.svg"),
    unlocked: require("../../assets/icons/calendar.svg")
  }
};

export default images;
